import { Component } from 'react';
import { connect } from 'react-redux';

import Home from '../home/';
import { Helmet } from 'react-helmet';
import { set } from 'actions/configuration';

class VolkswagenHome extends Component {
  constructor(props) {
    super(props);

    this.props.set({
      brand: 'vw',
      style: 'blue',
      brand_id: 1,
      legacy_service_option: false,
    });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Yacopini Süd - Turnos de taller Volkswagen</title>
          <meta name="description" content="Turnos de taller/postventa para tu Volkswagen" />
          <link rel="icon" href="favicon-vw.ico" type="image/ico" />
        </Helmet>
        <Home />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    set: config => {
      dispatch(set(config));
    },
  };
};

export default connect(null, mapDispatchToProps)(VolkswagenHome);
